// src/AsteroidAPI.js
export async function fetchAsteroidData(date) {
    const apiKey = process.env.REACT_APP_NASA_API_KEY;
    const url = `https://api.nasa.gov/neo/rest/v1/feed?start_date=${date}&end_date=${date}&api_key=${apiKey}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`NASA API error: ${res.statusText}`);
    return res.json();
}